import { i18n } from "@app/internationalization/providers/InternationalizationProvider";
import * as yup from "yup";

const normalize = (val: unknown) =>
    (typeof val === "string" ? val : "")
        .trim()
        .toLowerCase();

export const createConfirmationSchema = (confirmationRequiredString?: string) => {
  const baseField = yup.string().default("");

  if (!confirmationRequiredString) {
    return yup.object({
      confirmation: baseField,
    });
  }

  const requiredNormalized = normalize(confirmationRequiredString);

  const confirmationField = baseField
      .transform((value) => (typeof value === "string" ? value.trim() : value))
      .required(
          // More natural for the “typed confirm” UI
          i18n.t("user:validation.type_to_continue", {
            text: confirmationRequiredString,
            defaultValue: `Type ${confirmationRequiredString} to continue`,
          }),
      )
      .test(
          "matches-required-text",
          i18n.t("user:validation.type_exact_word", {
            text: confirmationRequiredString,
            defaultValue: `Type ${confirmationRequiredString} to continue`,
          }),
          (value) => normalize(value) === requiredNormalized,
      );

  return yup.object({
    confirmation: confirmationField,
  });
};

export const validationSchema = createConfirmationSchema();
export type ConfirmationFormSchema = yup.InferType<typeof validationSchema>;
